<ng-template #radioLabel>
    <ng-content></ng-content>
</ng-template>

<ng-template #radioSupportingText>
    <ng-content select="[radioSupportingText]"></ng-content>
</ng-template>
